<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-2 border-2 border-base-200 rounded-md p-4">
      <div class="text-secondary text-2xl font-bold">Allgemein</div>

      <div class="grid grid-cols-2 justify-between gap-4 items-center">
        <label-component label="Identifier" postfix="(identifier)" />
        <input-component type="text" placeholder="Identifier" v-model="scope.identifier" />
      </div>

      <div class="grid grid-cols-2 justify-between gap-4 items-center">
        <label-component label="Name" postfix="(name)" />
        <input-component type="text" placeholder="Name" v-model="scope.name" />
      </div>

      <div class="grid grid-cols-2 justify-between gap-4 items-center">
        <label-component label="Beschreibung" postfix="(description)" />
        <input-component type="text" placeholder="Beschreibung" v-model="scope.description" />
      </div>
    </div>

    <div class="flex flex-col gap-2 border-2 border-base-200 rounded-md p-4">
      <div class="text-secondary text-2xl font-bold">Claims</div>

      <table class="table w-full">
        <!-- head -->
        <thead>
        <tr>
          <th></th>

          <th>Name</th>
          <th>Claim</th>
        </tr>
        </thead>
        <tbody>

        <!-- rows -->
        <tr v-for="(claim, index) of claimsStore.getClaims" v-bind:key="index">
          <th>
            <label>
              <input type="checkbox"
                     class="checkbox"
                     :checked="hasClaim(claim.identifier)"
                     @change="change(claim.identifier)"
              />
            </label>
          </th>

          <td>{{ claim.name }}</td>
          <td>{{ claim.identifier }}</td>
        </tr>
        </tbody>

        <!-- foot -->
        <tfoot>
        <tr>
          <th></th>
          <th>Name</th>
          <th>Claim</th>
        </tr>
        </tfoot>
      </table>
    </div>

    <div class="self-end">
      <button-component fa-icon="fa-regular fa-floppy-disk" @click="$emit('save', scope)"></button-component>
    </div>
  </div>
</template>

<script>
import LabelComponent from "@/components/LabelComponent";
import InputComponent from "@/components/InputComponent";
import { mapStores } from "pinia";
import { useClaimsStore } from "@/stores/claims";
import ButtonComponent from "@/components/ButtonComponent";

export default {
  name: "UpsertScopeComponent",
  components: { ButtonComponent, InputComponent, LabelComponent },
  props: ["modelValue"],
  data() {
    return {
      scope: undefined
    };
  },
  created() {
    this.scope = this.modelValue;
    this.claimsStore.fetchClaims();
  },
  computed: {
    ...mapStores(useClaimsStore)
  },
  watch: {
    scope: {
      handler() {
        this.$emit("update:modelValue", this.scope);
      },
      deep: true
    }
  },
  methods: {
    hasClaim(claim) {
      return this.scope.claims.includes(claim);
    },
    change(claim) {
      const index = this.scope.claims.findIndex((aClaim) => aClaim === claim);

      if (index === -1) {
        this.scope.claims.push(claim);
      } else {
        this.scope.claims.splice(index, 1);
      }

      //this.$emit("update:modelValue", this.scope);
    }
  }
};
</script>

<style scoped>

</style>